export default __webpack_public_path__ + "6488a980b17bba4642f979888030b958.webp";